import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLayout, { LegalDocBlocks, LegalSection } from './LegalPageLayout';
import { getLegalDoc } from './content';

function useLegalDoc(kind) {
  const { i18n, t } = useTranslation('login');
  const doc = useMemo(
    () => getLegalDoc(i18n.resolvedLanguage || i18n.language, kind),
    [i18n.resolvedLanguage, i18n.language, kind],
  );

  const updatedAtLabel = t('legal.updatedAt', {
    date: doc.updateDate,
    defaultValue: doc.chrome?.updatedAt?.replace('{{date}}', doc.updateDate) || `Updated: ${doc.updateDate}`,
  });
  const backToLoginLabel = t('legal.backToLogin', {
    defaultValue: doc.chrome?.backToLogin || 'Back to login',
  });

  return { doc, updatedAtLabel, backToLoginLabel };
}

function LegalDocumentView({ kind, otherDocLink }) {
  const { doc, updatedAtLabel, backToLoginLabel } = useLegalDoc(kind);

  return (
    <LegalPageLayout
      title={doc.title}
      updateDate={doc.updateDate}
      intro={doc.intro}
      otherDocLink={otherDocLink}
      otherDocLabel={doc.otherDocLabel}
      updatedAtLabel={updatedAtLabel}
      backToLoginLabel={backToLoginLabel}
    >
      {(doc.sections || []).map((section) => (
        <LegalSection key={section.title} title={section.title}>
          <LegalDocBlocks blocks={section.blocks} />
        </LegalSection>
      ))}
    </LegalPageLayout>
  );
}

export function LegalTermsPage() {
  return <LegalDocumentView kind="terms" otherDocLink="/legal/privacy" />;
}

export function LegalPrivacyPage() {
  return <LegalDocumentView kind="privacy" otherDocLink="/legal/terms" />;
}
